<template>
  <div class="main-file">
    <header>
      <h3>文件管理</h3>
      <!-- <span>/ file upload</span> -->
    </header>

    <div class="total-Module">
      <!--树形-->
      <div class="treeShaped-Module">
        <a-button type="primary" icon="plus" block @click="addFolder('新增')" v-if="$IA('system:foldermanagement:save')">
          新增
        </a-button>


        <a-table :columns="orgColumns" :showHeader="false" :pagination="false" :data-source="orgTableData" class="components-table-demo-nested" @expand="allExpandedRowsChange">
          <template slot="expandIcon" slot-scope="props">
            <template >
              <a-icon
                  style="margin: 0 4px 0 0;font-size: 14px"
                  :type="props.expanded ? 'caret-down' : 'caret-right'"
                  @click="
	              (e) => {
	                props.onExpand(props.record, e);
	              }
	            "
              />
            </template>
          </template>

          <template slot="name" slot-scope="text">
            <img src="../assets/images/oneLevel_icon.png" class="img-lc" alt="" />
            <span :title="text">{{ text }}</span>
          </template>

           <a-tree
               :loading="dataShow"
               show-icon
               slot="expandedRowRender"
               slot-scope="text"
               default-expand-parent
               :tree-data="factorTreeData[text.id]"
               :defaultExpandAll="true"
               :autoExpandParent="true"
               :default-selected-keys="selectedKeys"
               @select="onTreeSelect">
               <template slot="custom" slot-scope="item">
               <div @mouseenter="onMouseEnter(item)" @click="singlePoint(item)" @mouseleave="onMouseLeave" style="position: relative;">
               <span class="treeMode">
                 <a-icon v-if="!item.isLeaf"  theme="filled":type="item.expanded ? 'folder-open' : 'folder'" />
                 <a-icon theme="filled" type="folder"  v-if="item.isLeaf"/>
                 <span style="margin-left: 5px">
                   {{ item.folderName }}
                 </span>
               </span>
                 <a-space
                     @click.stop
                     v-if="mouseItemId === item.id"
                     class="operation-Column"
                 >
                   <a-icon type="form" v-if="$IA('system:foldermanagement:update')" @click="treeNodeOpen(item,'编辑')"/>
                   <a-icon type="plus-circle" v-if="$IA('system:foldermanagement:save')" @click="treeNodeOpen(item,'添加')"/>
                   <a-icon type="delete" v-if="$IA('system:foldermanagement:delete')" @click="treeNodeOpen(item,'删除')" />
                 </a-space>
               </div>
             </template>
           </a-tree>

          <span slot="operation" slot-scope="record" class="table-operation">
              <a-icon type="plus-circle" style="color: #ffbd27;font-size: 19px" theme="filled" @click="treeNodeOpen(record,'部门添加')" />
          </span>



        </a-table>









      </div>
      <a-divider  type="vertical" />
      <!--表格-->
      <div class="form-Module">
        <main>
          <!-- 表格搜索栏 -->
          <div class="toolbar">
            <div class="search-bar">
              <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
                <a-form-model-item prop="searchText">
                  <a-input-search placeholder="文件名称" v-model="pagination.searchText" @input="searchTextChange" allow-clear
                                  :loading="btnLoad" />
                </a-form-model-item>
                <a-form-model-item style="vertical-align: middle; margin-top: -1px;">
                  <a-button icon="redo" @click="resetSearch">重 置</a-button>
                </a-form-model-item>
              </a-form-model>

            </div>
            <div class="btn-group">
              <a-button type="primary" icon="upload" v-if="$IA('system:filemanagement:upload')"   :disabled="this.selectFolderIds == 0" @click="handleOpen('上传')">上传
              </a-button>
              <a-button :lodiang="submitLoad" v-if="$IA('system:foldermanagement:deleteBatch')"  :disabled="foledrData.length == 0" icon="delete" @click="batchDeletion('批量删除')" >批量删除</a-button>

            </div>
          </div>
          <!-- 数据表格 -->
          <a-table :columns="tableColumns"  bordered :rowSelection='rowtriggerSelection' :data-source="tableData" @change="handleTableChange" :pagination="queryCondition" >
            <span slot="customTitle">文件名称</span>
            <template slot="fileSize" slot-scope="text">
              <span>
                  {{(text / 1024).toFixed(2)}}(KB)
              </span>
            </template>
            <template slot="fileStatus" slot-scope="text">
              <span v-if="text === 0"><a-tag color="green"> 空闲 </a-tag></span>
              <span v-else><a-tag color="orange">占用</a-tag></span>
            </template>
            <span slot="action" slot-scope="text, record" class="table-action-box">
               <a-tooltip  content="" v-if="$IA('system:org:update')" title="下载" placement="top" effect="light">
                          <a  v-if="$IA('system:attachmentManage:download')"  :href="axios.defaults.baseURL + '/attachmentManage/download' + '?token=' + $store.state.user.token + '&id=' + record.fid" target="_blank">    <i class="table-download" style="    vertical-align: middle;
    margin: -2px 5px 0px 5px;"></i> </a>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:filemanagement:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected"  @click="batchDeletion('批量删除',record)"  ></i>
            </a-tooltip>

            </span>
          </a-table>
        </main>
      </div>
    </div>
    <!-- 操作模态框 -->
    <a-modal centered :title="modalTitle + '文件'" :visible="modalVisible" :confirm-loading="btnLoad"
       :footer="modalTitle == '查看' ? null : undefined" @cancel="fileClose" >
      <div v-if="modalTitle == '上传'">

        <a-upload name="file" :multiple="false" :remove="handleRemove"  :before-upload="beforeUpload"    :fileList="completeFileList"
          >
          <a-button type="primary">
              <a-icon type="upload" /> 点击上传
          </a-button>
        </a-upload>
        <h4 style="color: #999;margin-top: 15px">单次上传文件个数不超过1个，且不超过{{ this.$cookies.get('uploadLibraryMaxFileSize') }}MB</h4>

      </div>
      <template slot="footer">
        <a-button @click="fileClose" >关闭</a-button>
        <a-button @click="handleUpload" type="primary"   :disabled="completeFileList.length === 0" :loading="uploading" >提交</a-button>
      </template>
    </a-modal>

   <!--新建/编辑文件夹-->
    <a-modal centered :title="modalTitle" :visible="addModalVisible" :confirm-loading="btnLoad" @ok="fileSubmit"
             @cancel="fileResetForm" >
      <a-form-model
          :model="addFolderForm"
          ref="addFolderForm"
          :rules="addFolderFormRules"

      >
      <a-form-model-item  prop="id" v-show="false">
        <a-input v-model="addFolderForm.id" placeholder="请输入" />
      </a-form-model-item>
        <a-form-model-item  prop="parentId" v-show="false">
          <a-input v-model="addFolderForm.parentId" placeholder="请输入" />
        </a-form-model-item>
      <a-row :gutter="23">
        <a-col :span="24">
              <a-form-model-item prop="orgId" label="部门">
                <a-select v-model="addFolderForm.orgId" :disabled="deleteTags !='主级新增'" placeholder="部门"  allowClear
                >
                  <a-select-option  v-for="item in orgTableData" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item prop="folderName" label="文件夹名称">
            <a-input  v-model.trim="addFolderForm.folderName" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>
      </a-form-model>
    </a-modal>




    <!--左侧提示框-->
    <a-modal centered title="提示" :visible="promptModalVisible"
             @cancel="promptModalVisible = false" >

      <div class="deleteBox" v-if="deleteTags == '已有子级'">
        <a-icon type="exclamation-circle" theme="filled" /> <p>{{promptText}}</p>
      </div>

      <div v-else class="deleteBox">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>删除文件夹将删除该文件夹下所有文件和文件夹</p>
      </div>
<!--      -->
<!--      <div v-else class="tips-div">-->
<!--        <a-icon type="info-circle" style="vertical-align: middle;margin-top: -20px;" />-->
<!--           <div class="delete-tips">-->
<!--             <label>确定继续吗？</label>-->
<!--             <span>*删除文件夹将删除该文件夹下所有文件和文件夹</span>-->
<!--           </div>-->
<!--      </div>-->

      <template slot="footer">
          <a-button v-if="this.deleteTags == '已有子级'" @click="promptModalVisible = false" type="primary">关闭</a-button>
          <div v-else>
            <a-button key="back" @click="promptModalVisible = false">
              取消
            </a-button>
            <a-button key="submit" type="primary"   :loading="submitLoad" @click="deleteSubmit">
              确定
            </a-button>
          </div>
      </template>
    </a-modal>

    <!--右侧提示框-->
    <a-modal centered title="提示" :visible="deleteModalVisible"
             @cancel="deleteModalVisible = false" >

      <div  class="tips-div">
        <a-icon type="exclamation-circle" theme="filled" />
        <div class="delete-tips">
          <label>{{this.singleDta? '此操作将永久删除该文件，是否继续?' : '此操作将永久删除已勾选文件，是否继续?'}}</label>
          <span style="color: red">*注意:有可能包含重要文件!</span>
        </div>

      </div>
      <template slot="footer">
          <a-button key="back" @click="deleteModalVisible = false">
            取消
          </a-button>
          <a-button key="submit" type="primary"   :loading="submitLoad"  @click="deleteSub" >
            确定
          </a-button>
      </template>
    </a-modal>


    <!--左侧提示框-->
    <a-modal centered title="提示" :visible="fileModalVisible"
             @cancel="fileModalVisible = false" >

      <div class="tips-div" >
        <a-icon type="info-circle" /> <p>已存在相同名称的文件，覆盖还是取消</p>
      </div>

      <template slot="footer">
          <a-button key="back" @click="fileModalVisible = false">
            取消
          </a-button>
          <a-button key="submit" type="primary"   :loading="submitLoad" @click="handleUpload">
            覆盖
          </a-button>
      </template>
    </a-modal>


  </div>
</template>

<script>



import {notification} from "ant-design-vue";

export default {
  computed: {
    rowtriggerSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {

          this.foledrData = selectedRows
          this.selectedfoledrRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            disabled:null, // Column configuration not to be checked
          },
        }),
        selectedRowKeys: this.selectedfoledrRowKeys,
      };
    },
  },
  data() {
    return {
      // 多选
      selectedfoledrRowKeys:[],
      foledrData:[],
      // 按钮加载
      uploading:false,
      btnLoad: false,
      tableLoad: false,
      pagination: {
        folderId:'',
        searchText: "",
        pageSize: 10,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      formLayout: "inline",
      queryCondition: {},
      tableColumns: [
        {
          dataIndex: "fileName",
          key: "fileName",
          ellipsis: true,
          slots: { title: "customTitle" },
          scopedSlots: { customRender: "fileName" },
          width: '30%'
        },
        {
          title: "文件大小",
          dataIndex: "fileSize",
          key: "fileSize",
          scopedSlots: { customRender: "fileSize" },
        },
        {
          title: "状态",
          dataIndex: "fileStatus",
          key: "fileStatus",
          scopedSlots: { customRender: "fileStatus" },
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          key: "updateTime",
          ellipsis: true,
        },
        {
          title: "上传者",
          dataIndex: "createUserName",
          key: "createUserName",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 100,
        },
      ],
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: "",
      // 添加表单
      addForm: {
        name: "",
        type: undefined,
        describe: "",
      },
      completeFileList: [],
      orgList:[],
      // 树结构
      factorTreeData: [],
      expandedKeys: [],
      selectedKeys: [],
      mouseItemId: '',
      // 弹窗
      visible: false,
      formObj: {},
      // 单条数据
      singleDta:"",
      // 删除标记
      deleteTags:'',
      promptText:'',



      // 新建/编辑
      addModalVisible:false,
      promptModalVisible:false,
      addFolderForm:{
        id:'',
        orgId:undefined,
        folderName:'',
        parentId:'',
      },
      addFolderFormRules: {
        orgId: [{ required: true, message: "部门不能为空" }],
        folderName: [
            { required: true, message: "文件夹名称不能为空" },
            { pattern: /^[^/@/.$%&*]{1,50}$/, message: '长度最长为50个字符且不允许包含特殊字符 /@~.$%&*', trigger: 'blur', },
        ],
      },
      // 左侧一级部门
      selectFolderIds:'',
      dataShow:false,
      submitLoad:false,
      saveApi:'',
      orgTableData:[],
      orgTreeIds:[],
      orgColumns: [
        {
          title: "部门",
          dataIndex: "name",
          key: "name",
          width: '100%',
          ellipsis: true,
          scopedSlots: { customRender: "name" },
        },
        {
          title: 'Action',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        },
      ],


      // 右侧表格操作
      deleteModalVisible:false,
      fileModalVisible:false,
      isOverride:false,


      deleteApi:''
    };
  },

  methods: {
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title
      this.modalVisible = true
    },
    // 下载文件
    downloadClose(title, data) {
      let download =
        this.axios.defaults.baseURL +
        "/document/download" +
        "?token=" +
        this.$store.state.user.token +
        "&fileId=" +
        data.id
      window.open(download, '_blank')
    },
    // 确认模态框
    handleOk() {
      this.completeFileList = []
      this.modalVisible = false
      this.handleTableChange(this.pagination)
    },
    // 判断是否上传文件
    beforeUpload(file) {
      this.isOverride = false
      this.completeFileList = [...this.completeFileList, file];
      //限制文件只能上传一个
      this.completeFileList = this.completeFileList.slice(-1);

      if (this.completeFileList[0].size / 1024 / 1024 >this.$cookies.get('uploadLibraryMaxFileSize')) {
        this.$message.warning('文件大小超过'+this.$cookies.get('uploadLibraryMaxFileSize')+'请重新上传文件');
        this.completeFileList = []
        return false
      }
      return false
    },
    // 选择文件上传
    handleUpload() {

      const { completeFileList } = this;
      const formData = new FormData();
      completeFileList.forEach(file => {
        formData.append('file', file);
        formData.append('folderId', this.selectFolderIds);
        formData.append('isOverride', this.isOverride);
      });
      this.uploading = true;

      this.axios
          .post('/filemanagement/upload', formData)
          .then((res) => {
            if (res.code == 200) {
              if (res.data){
                this.isOverride = true
                this.modalVisible = false
                this.fileModalVisible = true
                this.uploading = false;
              }else{
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.completeFileList = [];
                this.uploading = false;
                this.modalVisible = false
                this.fileModalVisible = false
                this.handleTableChange(this.pagination);
              }
              this.getTreeData(  this.addFolderForm.orgId)
            }
          })
          .catch((err) => {
            console.log(err);
          });



    },
    // 清空文件夹退出
    fileClose() {
      this.completeFileList = []
      this.modalVisible = false
      this.handleTableChange(this.pagination)
    },
    // 删除文件
    handleRemove(file) {
      const index = this.completeFileList.indexOf(file);
      const newFileList = this.completeFileList.slice();
      newFileList.splice(index, 1);
      this.completeFileList = newFileList;
    },
    // 部门
    allorgList(){
      this.axios
          .post("/org/findParentOrg",)
          .then((res) => {
            if (res.code === 200) {
              this.orgTableData = res.data
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 批量删除||删除
    batchDeletion(title,data){
      this.modalTitle = title
      this.singleDta = data
      switch (title) {
        case '删除':
          this.deleteApi = '/filemanagement/delete/'
          break
        case '批量删除':
          this.deleteApi = '/filemanagement/deleteBatch'
          break
      }
      this.deleteModalVisible = true

    },
    // 批量删除||删除 提交
    deleteSub(){
      let foledrIds = []
      if (this.singleDta){
        foledrIds.push(this.singleDta.id)
      }else{
        this.foledrData.forEach((item) => {
          foledrIds.push(item.id);
        });
      }
      this.submitLoad = true

      switch (this.modalTitle) {
        case '删除':
          this.axios
              .delete(this.deleteApi +  this.singleDta.id)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.deleteModalVisible = false
                  this.selectedfoledrRowKeys = []
                  this.foledrData = []
                  this.getTreeData(  this.addFolderForm.orgId)
                  this.handleTableChange(this.pagination);
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          break
        case '批量删除':
          this.axios
              .post(this.deleteApi,foledrIds )
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.deleteModalVisible = false
                  this.selectedfoledrRowKeys = []
                  this.foledrData = []
                  this.getTreeData(  this.addFolderForm.orgId)
                  this.handleTableChange(this.pagination);
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          break
      }


    },
    // 树形 start
    singlePoint(data){  // 点击文件夹请求表格
      this.selectFolderIds = data.id
      this.pagination.folderId = data.id
      this.searchChange();

    },
    allExpandedRowsChange(expanded, record){  // 展开行拿到当前部门数据
      if (expanded){
        this.$nextTick(()=>{
          this.getTreeData( record.id )
        })
      }
    },
    addFolder(title){  //新建文件夹
      this.addModalVisible = true
      this.modalTitle = title
      this.deleteTags = '主级新增'
      this.saveApi = '/foldermanagement/save'
      this.$refs.addFolderForm.resetFields()

    },
    fileResetForm() {  // 重置表单通用方法
      this.$refs.addFolderForm.resetFields()
      this.addModalVisible = false
    },
    getTreeData (id) {  // 获取树（模拟数据）
      this.dataShow = true
      this.axios
          .post("/foldermanagement/findPage",this.$qs.stringify({orgId:id}))
          .then((res) => {
            if (res.code === 200) {
              let obj = res.data
              this.dataShow = false
              this.factorTreeData[id] = this.dealTreeData(obj || [])
            }
          })
          .catch((err) => {
            this.dataShow = false
            console.log(err);
          });
      // 默认展开节点,显示操作栏
      // this.selectedKeys = [this.factorTreeData[0].children[0].key]
      // this.mouseItemId = this.factorTreeData[0].children[0].key
    },

    dealTreeData (dataArr) { // 给每个节点添加自定义属性
       dataArr.forEach((el, i) => {
        el.value = el.key
        if (el.children && el.children.length > 0) {
          el.isLeaf = false
          // el.selectable = false  // 设置父节点不可选中
          el['scopedSlots'] = { title: 'custom' }
          this.dealTreeData(el.children)
        } else {
          el.isLeaf = true
          el['scopedSlots'] = { title: 'custom' }
        }
      })
      return dataArr
    },

    onTreeSelect (selectedKeys) { // 节点选择事件
    },

    onMouseEnter (item) {    // 树鼠标悬停事件
      this.mouseItemId = item.id
    },

    onMouseLeave(){   // 树鼠移出事件
      this.mouseItemId = ''
    },


    treeNodeOpen(data,title){  // 操作栏
      this.singleDta = data
        switch (title) {
          case '添加':
            this.addModalVisible = true
            this.deleteTags = '新增'
            this.modalTitle = '新增'
            this.saveApi = '/foldermanagement/save'
            this.addFolderForm.id = ''
            this.addFolderForm.folderName = ''
            this.addFolderForm.parentId = data.id
            this.addFolderForm.orgId = data.orgId
            break
          case '部门添加':
            this.addModalVisible = true
            this.deleteTags = '新增'
            this.modalTitle = '新增'
            this.saveApi = '/foldermanagement/save'
            this.addFolderForm.id = ''
            this.addFolderForm.folderName = ''
            this.addFolderForm.parentId = ''
            this.addFolderForm.orgId = data.id
            break
          case '编辑':
            this.saveApi = '/foldermanagement/update'
            if (data.children ||data.hasFile == 1 ){
              this.deleteTags = '已有子级'
              this.promptText = '该文件夹下已有文件夹或者已有文件，不允许编辑'
              this.promptModalVisible = true
            }else{
              this.deleteTags = '编辑'
              this.addModalVisible = true
              this.modalTitle = '编辑'
              this.addFolderForm = this.$lodash.pick(
                  data,
                  this.$lodash.keys(this.addFolderForm)
              );
            }


            break
          case '删除':
            this.addFolderForm.orgId = data.orgId
            // if (data.children || data.hasFile == 1 ){
            //   this.deleteTags = '已有子级'
            //   this.promptText = '该文件夹下已有文件夹或者已有文件，不允许删除'
            // }else{
            //   this.deleteTags = '删除'
            // }
            this.deleteTags = '删除'
            this.promptModalVisible = true
            break
        }
    },
    fileSubmit(){ // 新建||编辑提交
      this.$refs.addFolderForm.validate((valid) => {
        if (valid) {
          this.btnLoad = true;
          let saveData = this.$lodash.cloneDeep(this.addFolderForm);
          this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.btnLoad = false;
                if (res.code === 200) {
                  this.addModalVisible = false
                  this.allorgList()
                  this.getTreeData(  this.addFolderForm.orgId)
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                }
              })
              .catch((err) => {
                this.btnLoad = false;
                console.log(err);
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteSubmit(){  // 删除文件夹
      this.submitLoad = true;
      this.axios
          .delete("/foldermanagement/delete/" + this.singleDta.id)
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.promptModalVisible = false;
              this.allorgList()
              this.getTreeData(  this.addFolderForm.orgId)
              this.handleTableChange(this.pagination);

            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
    },
    // 树形 end






    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =   pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
        .post("/filemanagement/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount() {
    this.allorgList()

  }
};
</script>

<style lang="scss" scoped>
.main-file {
  header {
    display: flex;
    align-items: flex-end;
    margin: -7px -8px 0;
    padding: 16px;
    letter-spacing: 1px;
    background-color: #fff;

    h3 {
      margin-bottom: 0;
      line-height:16px;
      padding-left: 12px;
      border-left: 4px solid #3373f2;
      font-size: 18px;
      //font-weight: bold;
    }

    span {
      line-height: 16px;
      margin-left: 10px;
      color: #808080;
    }
  }


  .total-Module{
    display: flex;
    background: #fff;
    margin: 15px;
    min-height: 780px;
    .treeShaped-Module{
      width: 30%;
      margin: 16px 8px 16px 16px;
      height:750px;
      min-height:750px;
      overflow:auto;
      padding: 1px;
      ::v-deep .ant-table{
        margin-top: 10px;
      }
      // 表格修改样式
      ::v-deep .ant-table-row-expand-icon-cell{
        width: 20px;
        min-width: 20px;
      }
      ::v-deep .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
        //background-color:transparent;
      }
      ::v-deep tr.ant-table-expanded-row{
        background-color: transparent;
      }
      ::v-deep .ant-table-tbody > tr > td{
        border-bottom: none;
      }
      ::v-deep .ant-table-tbody > tr {
        td{
          padding: 2px 16px;
          height: 30px;
          line-height: 30px;
        }
        td:nth-child(1){
          background: transparent;
          padding: 2px 0px !important;
          margin-bottom: 8px;

        }
        td:nth-child(2){
        }
        td:nth-child(3){
          display: inline-block;
          position: absolute;
          width: 43px;
          right: -1px;
          margin-top: 4px;
        }
      }
      ::v-deep .ant-table-tbody{
        .ant-table-expanded-row{
          td:nth-child(1){
            display: none;
          }
          td:nth-child(2){
            padding: 0px 8px;
          }
        }

        .ant-table-row-expand-icon-cell{
          padding: 16px 0px;
          display: inline-block;
        }
      }
      .operation-Column{
        position: absolute;
        right: 5px;
        top: 0;
        i{
          font-size: 15px;
        }
      }

      ::v-deep .ant-tree {
        margin-left: -10px;
        background-color: transparent;
        li {
          padding: 1px 0;
        }
        .ant-tree-switcher{
          margin-top: 3px;
          .ant-tree-switcher-icon{
            font-size: 16px;
          }
        }

        .ant-tree-node-content-wrapper {
          width: calc(100% - 15px);
          height: 32px;
          line-height: 32px;
        }
        .treeMode {
          height: 30px;
          width: 70%;
          display: flex;
          align-items: center;
          i{
            color: #ffbd27;
            font-size: 16px;
          }
          span {
            height: 30px;
            display: inline-block;
            max-width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-right: 5px;
          }
        }
      }
      ::v-deep  .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected{
        background-color: #f2f7ff;
      }
      ::v-deep .ant-tree li .ant-tree-node-content-wrapper:hover{
        background: #f6f7fb;
      }

      ::v-deep .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before {
        height: 32px;
      }


    }
    .ant-divider, .ant-divider-vertical{
      height: auto;
      width: 1px;
    }
    .form-Module{
      width: 69%;

      main {
        margin: 16px 0;
        background-color: #fff;
        margin: 16px 16px 16px 10px;
        //box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
        //0 1px 10px 0 rgba(0, 0, 0, 0.06);
        //border-radius: 4px;

        .toolbar {
          display: flex;
          justify-content: space-between;
          //padding: 16px 0;
          padding-bottom: 16px;
          .btn-group{
            ::v-deep .ant-btn:nth-child(1) {
               margin-right: 15px;
            }
           //::v-deep .ant-btn:nth-child(2) i{
           //   color: red;
           // }
          }
        }

        i.table-action {
          cursor: pointer;
          display: inline-block;
          margin: -5px 0;
          width: 30px;
          height: 30px;
          background: url("../assets/images/Table_action.png") no-repeat center;
          border-radius: 20px;
          vertical-align: top;

          &:active {
            background-color: #d8e6ff;
          }
        }

      }
    }
  }


}

.ant-operation-menu {
  display: flex;

  i {
    margin-top: 5px;
    font-size: 18px;
  }
}

::v-deep .version {
  .anticon {
    margin-right: 5px;
    color: #fa9635;
  }
}

.tips-div{
  display: flex;
  align-items: center;
  height: 80px;
  //border: 2px solid #fff3cd;
  border-radius: 4px;
  //background-color: #fffbe6;
  padding: 20px;
  p{
    margin-bottom: 0px;
    margin-left:10px;
    font-size: 15px;
    font-weight: 600;
  }
  i{
    color: #ff7d00;
    font-size: 20px;
    margin-top: -20px;
  }
  .delete-tips{
    display: flex;
    flex-direction: column;
    label{
    }
    margin-left:10px;

  }

}
.img-lc {
  vertical-align: middle;
  margin:-6px 4px 0 3px;
}



</style>
